import { render, staticRenderFns } from "./Citys.vue?vue&type=template&id=163116e8&scoped=true&"
import script from "./Citys.vue?vue&type=script&lang=js&"
export * from "./Citys.vue?vue&type=script&lang=js&"
import style0 from "./Citys.vue?vue&type=style&index=0&id=163116e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163116e8",
  null
  
)

export default component.exports